import React from 'react';
import PropTypes from 'prop-types';
import Link, { SecondaryLink } from 'jl-design-system/elements/link/Link';

const MyAccountLink = (props) => {
  const {
    className,
    isApps,
    level,
    text,
  } = props;

  if (isApps) {
    return text;
  }

  let link = '';

  if (window.publicJLSiteDomain.includes('johnlewis')) {
    link = '//account.johnlewis.com';
  }

  if (window.publicJLSiteDomain.includes('integration')) {
    link = '//account.integration.project4.com';
  }

  // can be extended in the future if we ever need to pass in primary etc.
  const LinkComponent = level === 'secondary' ? SecondaryLink : Link;

  return (
    <LinkComponent
      className={className}
      data-test={`my-account-link-${level || 'link'}`}
      external
      target="_blank"
      to={link}
    >{ text }
    </LinkComponent>
  );
};

MyAccountLink.propTypes = {
  className: PropTypes.string,
  isApps: PropTypes.bool,
  level: PropTypes.string,
  text: PropTypes.string,
};

MyAccountLink.defaultProps = {
  className: undefined,
  isApps: false,
  level: undefined,
  text: 'My Account',
};

export default MyAccountLink;
